import { mdiAlert } from '@mdi/js'

import { requiresSystemAccessMsg } from '../consts'
import { RequestSysAccessIcon, StyledRequestSysAccess } from './styles'

const RequestSysAccessMessage = () => (
  <StyledRequestSysAccess>
    <RequestSysAccessIcon path={mdiAlert} size={1} />
    {requiresSystemAccessMsg}
  </StyledRequestSysAccess>
)

export default RequestSysAccessMessage
